import React from 'react';
import Icon from './Icon';

const TONE_STYLES = {
  draft:     { bg: 'var(--ab-bg)',           fg: 'var(--ab-fg)',      border: 'var(--ab-fg)' },
  validated: { bg: 'var(--ab-approved-soft)', fg: 'var(--ab-approved)', border: 'var(--ab-approved)' },
  submitted: { bg: 'var(--ab-fg)',           fg: 'var(--ab-fg-inverse)', border: 'var(--ab-fg)' },
  approved:  { bg: 'var(--ab-approved-soft)', fg: 'var(--ab-approved)', border: 'var(--ab-approved)' },
  denied:    { bg: 'var(--ab-denied-soft)',   fg: 'var(--ab-denied)',  border: 'var(--ab-denied)' },
  pending:   { bg: 'var(--ab-pending-soft)',  fg: 'var(--ab-pending)', border: 'var(--ab-pending-ring)' },
  info:      { bg: 'var(--ab-info-soft)',    fg: 'var(--ab-info)',    border: 'var(--ab-info)' },
};

/**
 * @param {{ tone?: keyof typeof TONE_STYLES, icon?: string, children?: any }} props
 */
export default function Chip({ tone = 'draft', icon, children }) {
  const t = TONE_STYLES[tone] || TONE_STYLES.draft;
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: t.bg, color: t.fg,
        border: `1px solid ${t.border}`,
        borderRadius: 'var(--ab-radius-sm)',
        padding: '2px 8px',
        fontSize: 'var(--ab-text-xs)',
        fontWeight: 'var(--ab-weight-semi)',
        letterSpacing: 'var(--ab-tracking-label)',
        textTransform: 'uppercase',
      }}
    >
      {icon && <Icon name={icon} size={11} />}
      {children}
    </span>
  );
}
